import { render } from "./dialogDeliver.vue?vue&type=template&id=67a70b81&scoped=true"
import script from "./dialogDeliver.vue?vue&type=script&lang=js"
export * from "./dialogDeliver.vue?vue&type=script&lang=js"

import "./dialogDeliver.vue?vue&type=style&index=0&id=67a70b81&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a70b81"]])

export default __exports__